import { isElementVisible, scrollIntoView } from '../../shared/utils/dom';

export const setReadMoreListeners = (
  descriptionWrapperSelector: string = '.js-description-wrapper',
  toggleReadButtonSelector: string = '.js-toggle-read-more'
): void => {
  const descriptionWrappers = document.querySelectorAll<HTMLElement>(
    descriptionWrapperSelector
  );
  descriptionWrappers.forEach((descriptionWrapper) => {
    if (descriptionWrapper.dataset.readMoreInit) {
      return;
    }

    const readMoreButton = descriptionWrapper.querySelector<HTMLButtonElement>(
      toggleReadButtonSelector
    );

    if (!readMoreButton) {
      return;
    }

    descriptionWrapper.dataset.readMoreInit = 'true';

    readMoreButton.addEventListener('click', () => {
      descriptionWrapper.classList.toggle('hb-description-open');
      const isOpen = descriptionWrapper.classList.contains(
        'hb-description-open'
      );
      readMoreButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (!isOpen && !isElementVisible(descriptionWrapper)) {
        requestAnimationFrame(() => {
          scrollIntoView(descriptionWrapper, 120);
        });
      }
    });
  });
};
